<template>
  <div>
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏（原section-3） -->
        <section class="fullpage-section section-3">
          <div class="section-3-container" :class="{ 'scrollable': currentIndex === 0 }">
            <div class="section-3-content">
              <div class="section-3-content_1">
                <div class="section-3-content_1_view">
                  <div class="section-3-content_1_title">星海无垠，是为征途；零碳必达，谓之心向</div>
                  <div class="section-3-content_1_imgView1">
                    <img class="section-3-content_1_imgView_img" src="@/assets/img/home/section-3-content_1_imgView1_img.png" alt="">
                  </div>
                </div>
              </div>
              <div class="section-3-content_2">
                <div class="section-3-content_2_text">当时代的浪潮奔涌至气候治理与人工智能的历史交汇点，</div>
                <div class="section-3-content_2_text">中碳普惠云科技早已不仅是见证者，更是笃定的探路先锋。</div>
                <div class="section-3-content_2_text">我们以大模型为炬，刺破行业传统认知迷雾；</div>
                <div class="section-3-content_2_text">以AI为帆，在浩渺的绿色征途中犁出清晰航迹。</div>
                <div class="section-3-content_2_text">我们不仅在书写当下的答案，</div>
                <div class="section-3-content_2_text">更在为双碳征程铸就一座穿透周期、指向未来的智能灯塔</div>
              </div>
              <div class="section-3-content_3">
                <img class="section-3-content_3_img" src="@/assets/img/home/section-3-content_3_about.png" alt="">
                <img class="section-3-content_3_about_personl" src="@/assets/img/home/section-3-content_3_about_personl.png" alt="">
              </div>
            </div>
            <Footer pageType="aboutus" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Footer from '@/components/footer/index'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Footer
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      sections: 1, // 总屏幕数量
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      isSection3Scrolling: false, // 第一屏内部是否正在滚动
      section3ScrollPosition: 0, // 第一屏内部滚动位置
      isChatScrolling: false,
      isBtnActive: 1,
    };
  },
  mounted() {
    this.addTrackpadSupport();
  },
  beforeDestroy() {
    this.removeTrackpadSupport();
  },
  methods: {
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
      // 监听触摸板手势
      document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
      document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
      // 如果正在滚动中，则忽略后续滚轮事件
      if (this.isScrolling) return;

      // 如果聊天容器正在滚动，忽略全屏滚动
      if (this.isChatScrolling) return;

      // 如果在第一屏（原section-3），优先处理内部滚动
      if (this.currentIndex === 0) {
        this.handleSection3Scroll(e);
        return;
      }

      // 对于非第三屏，阻止默认行为并处理全屏切换
      e.preventDefault();

      // 全屏切换逻辑
      if (e.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    },

    /**
     * 处理第一屏内部滚动
     */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用更大的容差）
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      
      // 如果不在边界，允许自然滚动（不阻止默认行为）
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
          // 不阻止默认行为，让浏览器处理自然滚动
        return;
      }
      
      // 如果在边界且只有一个屏幕，不处理全屏切换，允许弹性滚动
      if (this.sections === 1) {
        return;
      }
      
      // 如果在边界且有多个屏幕，阻止默认行为并处理全屏切换
      e.preventDefault();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
      if (this.currentIndex < this.sections - 1) {
        this.startScroll(this.currentIndex + 1);
      }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
      if (this.currentIndex > 0) {
        this.startScroll(this.currentIndex - 1);
      }
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
      this.isScrolling = true;
      this.currentIndex = index;
      
      // 滚动动画结束后重置状态
      setTimeout(() => {
          this.isScrolling = false;
      }, this.transitionDuration);
    },
  }
};
</script>

<style lang="scss" scoped>
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

.section-content {
 position: relative;
 width: 100%;
 height: 100%;
}

.topBT{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 360 / 1080);
  position: absolute;
  top: calc(100% * 83 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}

.section-1_top{
  width: 100%;
  height: 424px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background:url(../../assets/img/home/section-1_top_img.png) no-repeat center center;
  background-size: cover;

  .section-1_top_title{
    font-weight: 400;
    font-size: 48px;
    line-height: 150%;
    text-align: center;
    color: #fff;
  }

  .section-1_top_desc{
    font-weight: 300;
    font-style: Light;
    font-size: 18px;
    line-height: 150%;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    margin-top: 20px;
  }
  
  .section-1_top_btn{
    width: 180px;
    height: 46px;
    border-radius: 100px;
    background: #fff;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .section-1_top_btn_item{
      width: 174px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      color: rgba(0, 0, 0, 1);
      cursor: pointer;
      background: linear-gradient(270deg, #95D9C1 0%, #47789E 100%);
      color: #fff;
      font-weight: 700;
      font-style: Bold;
      border-radius: 100px;
    }
  }
}

.section-1_bottom{
  height: calc(100vh * 662 / 1080);
  left: 0;
  bottom: 0;
  width: 100%;
  position: absolute;
  z-index: 5;
  display: flex;
  justify-content: center;

  .section-1_bottom_img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

/* 各屏背景色 */
.section-1 {
  background: url(../../assets/img/home/back_2.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  .section-content_1{
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #8ECDB6 49.63%, #FFFFFF 100%);
    width: 100%;
    height: 100%;
  }
}

.section-3 {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }
     
    .section-3-content{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .section-3-content_1{
        width: 100%;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        display: flex;

        .section-3-content_1_view{
          width: 1000px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .section-3-content_1_title{
            font-weight: 700;
            font-style: Bold;
            font-size: 48px;
            line-height: 100%;
            color: rgba(0, 0, 0, 1);
            margin-top: calc(100vh * 265 / 1080);
          }

          .section-3-content_1_imgView1{
            width: 100%;
            height: 562px;
            margin-top: calc(100vh * 115 / 1080);

            .section-3-content_1_imgView_img{
              width: 100%;
              height: 100%;
            }
          }

          .section-3-content_1_desc{
            font-weight: 700;
            font-style: Bold;
            font-size: 48px;
            line-height: 100%;
            color: rgba(0, 0, 0, 1);
            margin-top: 215px;
          }

          .section-3-content_1_imgView2{
            width: 100%;
            height: 222px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 70px auto 155px;

            .section-3-content_1_imgView_img{
              width: 300px;
              height: 222px;
            }
          }
        }
      }

      .section-3-content_2{
        width: 100%;
        // height: 256px;
        overflow: hidden;
        background: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: calc(100vh * 60 / 1080) auto calc(100vh * 100 / 1080);

        .section-3-content_2_text{
          font-weight: 500;
          font-style: Medium;
          font-size: 24px;
          line-height: 175%;
          text-align: center;
          letter-spacing: 2px;
          color: rgba(0, 0, 0, 0.5);
        }

        .strong{
          font-weight: 500;
          font-style: Medium;
          color: rgba(0, 0, 0, 1);
        }
      }

      .section-3-content_3{
        width: 1630px;
        height: 340px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .section-3-content_3_img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top;
        }

        .section-3-content_3_about_personl{
          position: absolute;
          bottom: -80px;
          right: 170px;
          width: 170px;
          height: 247px;
          z-index: 100;
        }
      }
    }
  }
}
</style>